import Base from './components/cells/Base';
import Avatar from './components/cells/Avatar';
import { isSameAvatarCellContent } from './isSameAvatarCellContent';
import {
    createSyncPendingIndicator,
    shouldShowSyncPendingReviewIcon,
} from './components/syncListStatus/vanillaSyncPendingIcon';

const buildAvatarCellContent = (params) => {
    const avatarNode = Avatar(params);
    let cellContent = avatarNode;

    if (params.showSyncStatus && shouldShowSyncPendingReviewIcon(params.data)) {
        const tooltipText = params.syncPendingReviewTooltip || '';
        const wrapper = document.createElement('div');
        wrapper.className = 'w5-avatar-cell-with-sync';

        const main = document.createElement('div');
        main.className = 'w5-avatar-cell-with-sync__main';
        main.appendChild(avatarNode);

        wrapper.appendChild(main);
        wrapper.appendChild(createSyncPendingIndicator({ tooltipText, agGridParams: params }));
        cellContent = wrapper;
    }

    return Base(cellContent, params);
};

/**
 * Same as `avatarCell`, plus optional sync-warning icon at the end when row sync status
 * is pending review (id 3). Expects `syncPendingReviewTooltip` in cellRendererParams (resolved literal).
 */
export default function AvatarCellWithSyncStatus() {}

AvatarCellWithSyncStatus.prototype.init = function (params) {
    this.params = params;
    this.eGui = buildAvatarCellContent(params);
};

AvatarCellWithSyncStatus.prototype.refresh = function (params) {
    const rowChanged = this.params?.node?.id !== params?.node?.id;
    if (!rowChanged && isSameAvatarCellContent(this.params, params)) {
        this.params = params;
        return true;
    }

    this.params = params;
    this.eGui = buildAvatarCellContent(params);
    return true;
};

AvatarCellWithSyncStatus.prototype.getGui = function () {
    return this.eGui;
};
